<!--
 * @Author: chenyingxuan chenyingxuan@abc.com
 * @Date: 2023-11-21 10:35:33
 * @LastEditors: chenyingxuan chenyingxuan@abc.com
 * @LastEditTime: 2024-01-19 10:33:25
 * @FilePath: /platform/src/views/flow/formFieldSelector.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <el-dialog :visible.sync="dialogTableVisible" title="扣税规则设置" width="700" append-to-body>
      <el-table :data="handleTransData(taxTypeList)">
        <el-table-column width="50">
          <template slot-scope="scope">
            <el-radio v-model="tableFullName" :label="scope.row.label" @change="tableChangeRadio($event, scope.row)"><i></i> </el-radio>
          </template>
        </el-table-column>
        <el-table-column property="label" label="字段" width="150" />
        <el-table-column property="value" label="代码" width="100" />
        <el-table-column property="explanation" label="取值说明" />
      </el-table>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogTableVisible = false">取消</el-button>
          <el-button type="primary" @click="handleNodeClick"> 确认 </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      filterText: '',
      dialogTableVisible: false,
      tableFullName: '',
      multipleChoice: ''
    }
  },
  props: {
    isShowCustom: {
      type: Boolean,
      default: () => false
    },
    source: {
      type: String,
      default: () => 'construction'
    }
  },
  computed: {
    ...mapState({
      taxTypeList: (state) => state.user.taxTypeList
    })
  },
  methods: {
    handleTransData(value) {
      let newArr = []
      if (this.source == 'design') {
        newArr = value.slice(0, 3)
      } else newArr = value
      let that = this
      return newArr.filter((item) => {
        if (!that.isShowCustom) return item
        else return item.basic === 'true'
      })
    },
    handleNodeClick() {
      if (this.multipleChoice) {
        let val = {
          label: this.multipleChoice.label,
          value: this.multipleChoice.value
        }
        this.dialogTableVisible = false
        this.$emit('setField', val)
      }
    },
    tableChangeRadio(event, payload) {
      this.tableFullName = event
      this.multipleChoice = payload
    },
    showDialog() {
      this.tableFullName = ''
      this.multipleChoice = ''
      this.dialogTableVisible = true
    }
  }
}
</script>
